import { Skeleton } from "@circleco/compass/components/Skeleton";

/** Reserves the video player's 16:9 footprint while the preview chunk loads. */
export const PreviewLoadingFallback = () => (
  <Skeleton shape="square" className="aspect-video w-full" />
);
